/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";

export default {
  enrollCourse({ commit }, user) {
    return new Promise((resolve, reject) => {
      axios
        .post("course-student", user)
        .then((response) => {
          console.log(user);
          commit("ADD_STUDENT", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getList({ commit }, param) {
    return new Promise((resolve, reject) => {
      axios
        .get(`course-student?${new URLSearchParams(param)}`)
        .then((response) => {
          const data = response.data.data;
          if (data && data.pagination) {
            commit("SET_LIST_WITH_PAGINATION", data);
          } else {
            commit("SET_LIST", data);
          }
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getDetail({ commit }, { id, query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`course-student/${id}?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_DETAIL", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  patchUpdateStudent({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`course-student/${id}`, payload, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          commit("UPDATE_STUDENT", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delete({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`course-student/${id}`)
        .then((response) => {
          commit("REMOVE_RECORD", id);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
